import {C240LoaderActions} from '../redux_constants/c240_loader.constant';

export const updateEditorState = (editor_state) => ({
    type: C240LoaderActions.UPDATE_C240_EDITOR_MODE,
    response: editor_state,
})


export const updateLoaderState = (loader_state) => ({
    type: C240LoaderActions.UPDATE_LOADER_STATE,
    response: loader_state,
})